import { create } from 'zustand'

const useStore = create((set) => {
    return {
        decorationTypeList: [],
    
        setDecorationTypeList: (decorationTypeList) => set({ decorationTypeList }),
    }
})
export default useStore